import type { IToastMessageType } from '../interface';

export const DEFAULT_SHOW_DURATION = 5000;
export const DEFAULT_TYPE: IToastMessageType = 'info';
